import { Alert } from '@material-ui/lab';
// TODO: create alert/snackbar ui component
import Paragraph from 'components/atoms/Paragraph/Paragraph';
import { Fragment } from 'react';
import { useRecoilValueLoadable } from 'recoil';

export const UpdateStatusLoadable = (props) => {
  const { value } = props;
  const { state, contents } = useRecoilValueLoadable(value);

  switch (state) {
    case 'hasValue':
      return Object.keys(contents).length ? (
        <Alert severity="success">
          <Paragraph>Updated successfully!</Paragraph>
          {props.type &&
            props.type === 'profileInfo' &&
            window.location.reload()}
        </Alert>
      ) : (
        <Fragment />
      );
    case 'loading':
      return (
        <Alert severity="info">
          <Paragraph>Update is in progress...</Paragraph>
        </Alert>
      );
    case 'hasError':
      return (
        <Alert severity="error">
          <Paragraph>
            Something went wrong!{' '}
            {contents.response && JSON.stringify(contents.response.data)}
          </Paragraph>
        </Alert>
      );
    default:
      return '';
  }
};
